export const STATIC_EXPORT_FORMATS = ['png', 'pdf-vector', 'pdf'] as const;
export type StaticExportFormat = (typeof STATIC_EXPORT_FORMATS)[number];

export const STATIC_EXPORT_RESOLUTIONS = [150, 300, 450, 600] as const;
export type StaticExportDpi = (typeof STATIC_EXPORT_RESOLUTIONS)[number];

export interface StaticExportRequest {
  readonly format: StaticExportFormat;
  readonly dpi: StaticExportDpi;
}

export const STATIC_EXPORT_MAX_CANVAS_PIXELS = 40_000_000;
/** Conservative full-page Canvas bound, separate from runtime WebGL map-frame limits. */
export const STATIC_EXPORT_MAX_PAGE_DIMENSION_PX = 8_192;

export class StaticExportError extends Error {
  readonly code:
    | 'canvas'
    | 'cors'
    | 'download'
    | 'encoding'
    | 'fonts'
    | 'image'
    | 'legend-overflow'
    | 'map-initialisation'
    | 'map-timeout'
    | 'output-limit'
    | 'page-limit'
    | 'pdf'
    | 'vector'
    | 'webgl-limit';

  constructor(code: StaticExportError['code'], message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'StaticExportError';
    this.code = code;
  }
}
